export const staircaseConfig = {
    gameSlug: 'alternative-uses',
    category: 'foudre_logique',
    variable: 'duration_ms',
    startValue: 60_000,
    minValue: 30_000,
    maxValue: 90_000,
    stepSizesByPhase: [15_000, 7_500, 5_000, 2_500],
    reversalsToConverge: 4,
    reversalsForThreshold: 3,
    /** 1 trial = 1 round 30-90 s ; on cap à 6 (durée totale ~5-9 min max). */
    maxTrials: 6,
    direction: 'down-easier',
};
function buildVariant(level) {
    if (level <= 10) {
        return {
            level,
            roundMs: 90_000,
            targetFluidity: 3,
            familiarity: 1,
            label: 'Objets familiers',
        };
    }
    if (level <= 20) {
        return {
            level,
            roundMs: 75_000,
            targetFluidity: 4,
            familiarity: 2,
            label: 'Objets courants',
        };
    }
    if (level <= 30) {
        return {
            level,
            roundMs: 60_000,
            targetFluidity: 5,
            familiarity: 3,
            label: 'Objets moyens',
        };
    }
    if (level <= 40) {
        return {
            level,
            roundMs: 45_000,
            targetFluidity: 6,
            familiarity: 4,
            label: 'Objets insolites',
        };
    }
    return {
        level,
        roundMs: 30_000,
        targetFluidity: 6,
        familiarity: 5,
        label: 'Objets bizarres',
    };
}
export const levels = Array.from({ length: 50 }, (_, i) => buildVariant(i + 1));
export function variantForLevel(level) {
    const idx = Math.max(1, Math.min(50, level)) - 1;
    return levels[idx];
}
export const timing = {
    primingMs: 800,
    feedbackMs: 1500,
    itiMs: 1000,
};
export const paradigmMeta = {
    slug: 'alternative-uses',
    paradigm: 'Alternative Uses Task (Guilford 1967)',
    category: 'creativity',
    goal: "Liste les utilisations alternatives possibles d'un objet en temps limité.",
};
//# sourceMappingURL=params.js.map